import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { isFunction } from 'lodash';

const getDefaultMessage = (label, plural) => {
    const pluralText = plural ? 'these items' : 'this item';
    return i18n._(t`Are you sure you want to <b>${label}</b> ${pluralText}`);
};

const ConfirmMsgDiv = ({ confirmMsg, plural, label }) => {
    if (isFunction(confirmMsg)) {
        return confirmMsg();
    }

    if (confirmMsg) {
        return confirmMsg;
    }

    const message = getDefaultMessage(label, plural);
    // eslint-disable-next-line react/no-danger
    return <div dangerouslySetInnerHTML={{ __html: message }} />;
};

ConfirmMsgDiv.propTypes = {
    confirmMsg: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
    plural: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
};

ConfirmMsgDiv.defaultProps = {
    confirmMsg: null,
    plural: false,
};

ConfirmMsgDiv.displayName = 'ConfirmMsgDiv';

export default memo(ConfirmMsgDiv);
